import React, { useEffect, useState, useContext, useCallback, useRef } from 'react'
import { store } from '../../../../../context/StateProvider'
import CommonService from '../../../../../services/api/common.service'
import AppointmentService from '../../../../../services/api/appointment.service'
import moment from 'moment';
import Utilities from '../../../../../services/commonservice/utilities'
import ModalBox from '../../../../templates/components/ModalBox'
import AddPatient from '../../patient/add-patient/AddPatient'
import InputMask from 'react-input-mask'
import PracticeLocationSelector from '../../../../templates/components/PracticeLocationSelector'
import AppointmentFormConfig from './appointment-form-config'
import toast from 'react-hot-toast'
import FormValidatorService from '../../../../../services/validator/form-validator.service'
import PatientService from '../../../../../services/api/patient.service'
import { debounce } from 'lodash'
import AsyncSelect from 'react-select/async';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { createPortal } from 'react-dom';
import DimLoader from '../../../../templates/components/DimLoader'
import { useMediaQuery } from 'react-responsive'
import { 
    useGetAppointmentStatusCodes, 
    useGetPracticePatientTypes, 
    useGetLocationEquipment, 
    useGetLocationRooms,
    useGetLocationServiceTypes,
    useGetLocationProviderServices,
    useGetAllPracticeServiceTypes
 } from "../../../../../services/cache/CacheService";
import CacheUtilities from '../../../../../services/cache/CacheUtilities'
import HPTSelect from '../../../../templates/components/HPTSelect'

const AppointmentForm = (props) => {
    // context state and dispatch 
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const hasInitialized = useRef(false);
    const [inputData, setInputData] = useState(props.initialData || {})
    const [showAdd, setShowAdd] = useState(false)
    // populate form 
    const [patientList, setPatientList] = useState()
    const [selectedPatient, setSelectedPatient] = useState()
    const statePatientTypeList = useGetPracticePatientTypes()
    const [patientTypeList, setPatientTypeList] = useState()
    const apptStatusList = useGetAppointmentStatusCodes();
    const [statusList, setStatusList] = useState();
    const [doctorList, setDoctorList] = useState();
    const [equipmentList, setEquipmentList] = useState()
    const [listEquipmentByServiceType, setListEquipmentByServiceType] = useState({})
    const [roomList, setRoomList] = useState()
    const [serviceTypeList, setServiceTypeList] = useState()
    const [allServiceTypeList, setAllServiceTypeList] = useState() // only called when Edit appt
    const [allEquipmentList, setAllEquipmentList] = useState()
    const [allRoomList, setAllRoomList] = useState()
    const stateDoctorList = useGetLocationProviderServices();
    const stateEquipmentList = useGetLocationEquipment()
    const stateRoomList = useGetLocationRooms()

    const stateServiceTypeList = useGetLocationServiceTypes()
    const stateAllPracticeServiceTypeList = useGetAllPracticeServiceTypes()
    const [locationId, setLocationId] = useState(); // (props?.initialData?.practiceLocationId || state.practiceLocationId)
    const [isLoader_Patients, setIsLoader_Patients] = useState(false)
    const [errors, setErrors] = useState({})
    const [childAppointments, setChildAppointments] = useState([])
    const  headerColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-light');
    const isMobile = useMediaQuery({ query: `(max-width: 576px)` });
    
    const [providerRequested, setProviderRequested] = inputData.providerRequested ? useState(Boolean(inputData.providerRequested)) : useState(false)
    //added to correct css for dragging and dropping of child apt over model
    const useDraggableInPortal = () => {
        const self = useRef({}).current;

        useEffect(() => {
            const div = document.createElement('div');
            div.style.position = 'absolute';
            div.style.pointerEvents = 'none';
            div.style.top = '0';
            div.style.width = '100%';
            div.style.height = '100%';
            self.elt = div;
            document.body.appendChild(div);
            return () => {
                document.body.removeChild(div);
            };
        }, [self]);

        return (render) => (provided, ...args) => {
            const element = render(provided, ...args);
            if (provided.draggableProps.style.position === 'fixed') {
                return createPortal(element, self.elt);
            }
            return element;
        };
    };

    const renderDraggable = useDraggableInPortal();
    const required = [
        "patientId",
        "practicePatientTypeId",
        // "doctorId",
        "practiceServiceTypeId",
        "practiceAppointmentStatusCodeId",
        "fromDate",
        "duration",
        "toDate",
        // "email",
    ];
    useEffect(() => {
        //console.log("stateAllPracticeServiceTypeList ::"+props?.isEdit + JSON.stringify(stateAllPracticeServiceTypeList))
        if (props?.isEdit && stateAllPracticeServiceTypeList ) {
            setAllServiceTypeList(stateAllPracticeServiceTypeList)
        }
    }, [stateAllPracticeServiceTypeList])
    
    useEffect(() => {
        if (apptStatusList) {
            setStatusList(apptStatusList)
        }
    }, [apptStatusList])

    useEffect(() => {
        if (statePatientTypeList) {
            setPatientTypeList(statePatientTypeList)
        }
    }, [statePatientTypeList])

    useEffect(() => {
        //console.log(props.initialData?.clear)
        if (props?.initialData?.clear) {
            setChildAppointments([])
        }
    }, [props.initialData?.clear])

    useEffect(()=>{
        if (allEquipmentList && Array.isArray(allEquipmentList)) {
            let newArray1 = allEquipmentList.filter(obj => obj.isActive === 1);
            setEquipmentList([...newArray1])
            //get practiceServiceTypeId is key and list of equipmentids as value from newArray1 
            let equipmentByServiceType = {}
            newArray1.forEach(equipment => {
                // Check if equipment has equipmentServices array
                if (equipment.equipmentServices && Array.isArray(equipment.equipmentServices)) {
                    equipment.equipmentServices.forEach(service => {
                        //console.log("service.isActive::"+service.isActive)
                        if (service.practiceServiceTypeId )
                        {
                            //&& service.isActive === 1) {
                            if (!equipmentByServiceType[service.practiceServiceTypeId]) {
                                equipmentByServiceType[service.practiceServiceTypeId] = [];
                            }
                            // Only add equipment if not already in the array for this service type
                            if (!equipmentByServiceType[service.practiceServiceTypeId].some(e => e.equipmentId === equipment.equipmentId)) {
                                equipmentByServiceType[service.practiceServiceTypeId].push(equipment);
                            }
                        }
                    });
                }
            });
            setListEquipmentByServiceType(equipmentByServiceType)
        }
    },[allEquipmentList])
    useEffect(()=>{
        if (allRoomList && Array.isArray(allRoomList)) {
            let newArray1 = allRoomList.filter(obj => obj.isActive === 1);
            setRoomList([...newArray1])
        }
    },[allRoomList])

    const getFormErrors = () => {
        const newErrors = {};
        if (
            !inputData['patientId']
        ) {
            newErrors['patientId'] = 'Patient is required'
        }
        if (
            !inputData['practicePatientTypeId']
        ) {
            newErrors['practicePatientTypeId'] = 'Patient Type is required'
        }
        // if (
        //     !inputData['doctorId']
        // ) {
        //     newErrors['doctorId'] = 'Provider is required'
        // }
        if (
            !inputData['practiceServiceTypeId']
        ) {
            newErrors['practiceServiceTypeId'] = 'Service Type is required'
        }
        if (
            !inputData['practiceAppointmentStatusCodeId']
        ) {
            newErrors['practiceAppointmentStatusCodeId'] = 'Status is required'
        }
        // if (
        //     !inputData['patientPhone']
        // ) {
        //     newErrors['patientPhone'] = 'Phone is required'
        // }
        // if (
        //     !inputData['email']
        // ) {
        //     newErrors['email'] = 'Email is required'
        // }

        if (
            !inputData['fromDate']
        ) {
            newErrors['fromDate'] = 'Start Date is required'
        }

        if (
            !inputData['toDate']
        ) {
            newErrors['toDate'] = 'End Date is required'
        }
        if (
            !inputData['duration']
        ) {
            newErrors['duration'] = 'Duration is required'
        }
        return newErrors;
    }

    const submitHandlerCatch = (data) => {
        if (props.disabled) {
            return;
        }

        // Ensure practiceLocationId is set
        if (!data.practiceLocationId) {
            data.practiceLocationId = locationId;
        }

        //console.log('Submitting form data:', data);

        if (!FormValidatorService.checkForm(errors, data, required)) {
            toast.error("Please make sure the form is complete")
        }
        else {
            props.submitHandler(data)
        }
    }


    const filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: 'any'
    };

    useEffect(() => {
        if (hasInitialized.current) return;

        if (!props?.initialData || !Array.isArray(statusList) || statusList.length === 0) return;

        let newData = { ...props.initialData };

        if ((props.isEdit === undefined || props.isEdit === false) && !newData.practiceAppointmentStatusCodeId) {
            const bookedStatus = statusList.find(
                obj => obj.appointmentStatusLabel?.toLowerCase() === 'booked'
            );
            //select booked if not present select the first record from the status list
            newData.practiceAppointmentStatusCodeId = bookedStatus?.practiceAppointmentStatusCodeId || statusList[0]?.practiceAppointmentStatusCodeId;
        }
        if (props.initialData.startDate && props.initialData.endDate) {
            newData.duration = moment(props.initialData.startDate).diff(moment(props.initialData.fromDate), "minutes")
        }
        if (props.initialData.startDate && !props.initialData.endDate && props.initialData.duration) {
            newData.endDate = moment(props.initialData.startDate).add(props.initialData.duration, "minutes")
        }
        if (props.initialData.duration) {
            newData.duration = props.initialData.duration
        }

        setInputData(newData);

        hasInitialized.current = true;
    }, [props?.initialData, statusList])

    const patientLookup = () => {
        setIsLoader_Patients(true)
        if (props.initialData.patientId) {
            PatientService.getPatientById(props.initialData.patientId)
                .then(res => {
                    setPatientList([res.data])
                    setIsLoader_Patients(false)
                })
        }
        else {
            setPatientList()
        }
    }


    const patientLoad = (inputText, callBack) => {
        if (inputText?.length < 3 && !props.initialData.patientId) return;
        let reqObj = { 
            SearchTerm: inputText, 
            isActive: true, 
            isRegistered: true,
            SortField: 'lastName',
            SortField2: 'firstName', 
            Asc: true,
            Asc2: true,
            }
        if (props.initialData.patientId) {
            reqObj.PatientIds = props.initialData.patientId
        }
        CommonService.patientLookup(reqObj)
            .then(res => {
                if (res) {
                    callBack(res.data)
                }
            }
            )
            .catch(err => console.log(err))
    }
    const rePatientLoad = useCallback(debounce(patientLoad, 500), [])



    const onPatientSelect = () => {
        let patient = patientList.find(obj => obj.id === inputData.patientId)
        if(patient){
            setSelectedPatient(patient)
        }
        let newStateObject = { ...inputData };
        if (patient && !props.isEdit) {
            if (patient.mobile) { newStateObject.patientPhone = patient.mobile }
            if (patient.email) { newStateObject.email = patient.email }
            if (patient.patientTypeId) { newStateObject.practicePatientTypeId = patient.patientTypeId }
            return setInputData(newStateObject);
        }
    }

    useEffect(() => {
        if (patientList && inputData.patientId) {
            onPatientSelect()
        }
    }, [patientList, inputData.patientId])

    // formula for input change
    const inputChange = (e) => {
        let newStateObject = { ...inputData };
        if (e.target.name === 'providerRequested') {
            newStateObject[e.target.name] = e.target.checked;
            setInputData(newStateObject);
            setProviderRequested(e.target.checked);
        } else {
            if (e.target.name === 'doctorId' && !(e.target.value)) {
                setServiceTypeList(stateServiceTypeList);
            }
            
            // Reset equipment if service type changes
            if (e.target.name === 'practiceServiceTypeId' && inputData.equipmentId) {
                // Check if service type actually changed
                const serviceTypeChanged = props.isEdit && props.initialData?.practiceServiceTypeId
                    ? e.target.value !== props.initialData.practiceServiceTypeId
                    : e.target.value !== inputData.practiceServiceTypeId;
                    
                if (serviceTypeChanged) {
                    newStateObject.equipmentId = null;
                }
            }
            
            newStateObject[e.target.name] = e.target.value;
            setInputData(newStateObject);
        }
        setErrors(FormValidatorService.setErrors(e, errors, AppointmentFormConfig.config));
    };

    const inputSubAptChange = (e) => {
        let newStateObject = { ...inputData };
        //console.log("inputSubAptChange::"+JSON.stringify(e))
        //console.log("inputSubAptChange::"+JSON.stringify(inputData))
        // console.log(e.target.index)
        newStateObject.childAppointments.map((item, i) => {
            if (i === e.target.index) {
                if (e.target.name == "duration") {
                    item[e.target.name] = parseInt(e.target.value)
                } else if (e.target.name === 'practiceServiceTypeId' && item.equipmentId) {
                    // Reset equipment if service type changes
                    const initialChild = props.isEdit && childAppointments?.[i];
                    const serviceTypeChanged = initialChild && initialChild.practiceServiceTypeId
                        ? e.target.value !== initialChild.practiceServiceTypeId
                        : e.target.value !== item.practiceServiceTypeId;
                    
                    if (serviceTypeChanged) {
                        item.equipmentId = null;
                    }
                    item[e.target.name] = e.target.value;
                } else {
                    item[e.target.name] = e.target.value
                }
            }
        });
        setInputData(newStateObject)
        //setErrors(FormValidatorService.setErrors(e, errors, AppointmentFormConfig.config))
        return 
    };

    useEffect(() => {
        if (inputData?.practiceServiceTypeId) {
            const selectedServiceType = getSelectedServiceTypeValue(inputData.practiceServiceTypeId);
            if (selectedServiceType) {
                updateTime({ target: { name: 'duration', value: selectedServiceType.defaultDuration } });
            }
        }
    }, [inputData?.practiceServiceTypeId])

    useEffect(() => {
        if (inputData?.doctorId==='999999999') return setServiceTypeList(stateServiceTypeList); 
        if (inputData?.doctorId && doctorList) {
            let matchedServiceTypes = fetchDoctorMatchedServiceTypes(inputData?.doctorId);
            setServiceTypeList(matchedServiceTypes)
        }
    }, [doctorList,inputData?.doctorId])

    useEffect(() => {
        const initializeLocation = () => {
            const locationToSet = props?.initialData?.practiceLocationId || state.practiceLocationId;
            setLocationId(locationToSet);
            
            // Ensure practiceLocationId is set in form data
            let newStateObject = { ...inputData };
            newStateObject.practiceLocationId = locationToSet;
            setInputData(newStateObject);
        };

        initializeLocation();

        if (props?.initialData?.patientId) {
            patientLookup()
        }

        if(props.initialData && props.initialData.id){
            findChildAppointment()
        }
    }, [])

    useEffect(() => {
        addChildApt()  
    }, [childAppointments]);

    const findChildAppointment = () => {
        let reqObj = {
            ParentGroupId: props.initialData.id,
            PracticeLocation: props.initialData.practiceLocationId
        }
        return AppointmentService.findNextAppointment(reqObj)
            .then(res => {
                let subApts = []
                //sorting response to add sequence number
                res.sort((a, b) => a.fromDate > b.fromDate ? 1 : -1).map((item, index) => {
                    let localItem = {
                        sequenceId: `item-${index}`,
                        "sequence": index,
                        id: item.id,
                        "duration": item.fromDate && item.toDate ? moment(item.toDate).diff(moment(item.fromDate), "minutes") : 0,
                        "doctorId": item.doctorId,
                        "equipmentId": item.equipmentId,
                        "practiceLocationRoomId": item.practiceLocationRoomId,
                        "practiceServiceTypeId": item.practiceServiceTypeId
                    }
                    subApts.push(localItem)
                })
                setChildAppointments(subApts)
            })
            .catch((err) => {
                setChildAppointments([])
            })
    }
    const updateTime = (e) => {
        let newStateObject = { ...inputData };
        newStateObject[e.target.name] = e.target.value
        if (e.target.name == 'duration') {
            newStateObject.toDate = moment(inputData.fromDate).add(e.target.value, "m")
        }
        if (e.target.name == 'toDate') {
            newStateObject.duration = moment(e.target.value).diff(moment(inputData.fromDate),"m")
        }
        if (e.target.name == 'fromDate') {
            newStateObject.toDate = moment(e.target.value).add(inputData.duration, "m")
        }
        return setInputData(newStateObject)
    }

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const appointments = reorder(
            childAppointments,
            result.source.index,
            result.destination.index
        );
        setChildAppointments(appointments);
        //console.log("after reorder ::"+JSON.stringify(appointments))
    }

    const getItems = () => {
        let localItem = {
            sequenceId: `item-${childAppointments.length}`,
            "sequence": childAppointments.length,
            "duration": 30,
            "doctorId": inputData?.doctorId && inputData?.doctorId !== '999999999' ? inputData?.doctorId : null,
            "equipmentId": null,
            "practiceLocationRoomId": null,
            "practiceServiceTypeId": null
        }
        setChildAppointments(prevChildAppointments => [...prevChildAppointments,localItem])
    };
    const addChildApt = () => {
        let newStateObject = { ...inputData };
        newStateObject.childAppointments = childAppointments
        setInputData(newStateObject)
    };

    // function to help us with reordering the result while dragging and dropping child apt
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };


    // const getItemStyle = (isDragging, draggableStyle) => ({
    //     // some basic styles to make the items look a bit nicer
    //     //userSelect: "none",
    //     //padding: grid * 2,
    //     //margin: `0 0 ${grid}px 0`,

    //     // change background colour if dragging
    //     //background: isDragging ? "lightgreen" : "",
    //     left: isDragging?  "auto":"",
    //     top: isDragging?  "auto":"",
    //     // styles we need to apply on draggables
    //     ...draggableStyle
    // });
    
    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }

    useEffect(() => {
        const updateLocation = async () => {
            if (locationId) {
                if (locationId == state.practiceLocationId) {
                    setDoctorList(stateDoctorList)
                    setAllEquipmentList(stateEquipmentList)
                    setAllRoomList(stateRoomList)
                    setServiceTypeList(stateServiceTypeList)
                }   
                else {
                    const [dummy, locEquipment, locProviderServices, locRooms, locServiceTypes] = await CacheUtilities.pullAllLocationData(locationId);
                    setDoctorList(locProviderServices)
                    setAllEquipmentList(locEquipment)
                    setAllRoomList(locRooms)
                    setServiceTypeList(locServiceTypes)
                }   
            }
        };
        updateLocation();
    }, [locationId]);    

    
    const getListStyle = isDraggingOver => ({
        // left: isDraggingOver?  "auto":"",
        // top: isDraggingOver?  "auto":"",
         background: isDraggingOver ? headerColor : "",
        // padding: grid,
        // width: 250
      });
    
    //common get the service type options
    const getServiceTypeOptions = (practiceServiceTypeId) => {
        if (props.isEdit && practiceServiceTypeId) {
            const existingOption = serviceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
            if (!existingOption) {
                const newOption = allServiceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
                if (newOption) {
                    return [...serviceTypeList, { ...newOption, isActive: 0 }];
                }
            }
        }
        return serviceTypeList;
    }

    //common get the selected service type value
    const getSelectedServiceTypeValue = (practiceServiceTypeId) => {
        if (practiceServiceTypeId) {
          if (props.isEdit) {
            const existingOption = serviceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
            if (!existingOption) {
              const newOption = allServiceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
              if (newOption) {
                return { ...newOption, isActive: 0 };
              }
            } else {
              return existingOption;
            }
          } else {
            return serviceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
          }
        } else {
          return null;
        }
      }

        // Returns the service types allowed for a given doctorId 
        const fetchDoctorMatchedServiceTypes = (doctorId) => {
            //console.log("fetchDoctorMatchedServiceTypes::"+JSON.stringify(doctorId))

            if (!doctorId || !doctorList) return [];
            const doc = doctorList.find(d => d.id === doctorId || d.doctorId === doctorId);
            const doctorServices = doc?.services || [];
           
             // return doctor matched serviceTypeList from stateServiceTypeList
            return stateServiceTypeList.filter(st =>
                doctorServices.some(ds => ds.practiceServiceTypeId === st.practiceServiceTypeId)
            );
        };
    
        const getChildServiceTypeOptions = (index) => {
            const child = inputData.childAppointments?.[index];
            if (!child?.doctorId) return stateServiceTypeList; 
            let matchedServiceTypes = fetchDoctorMatchedServiceTypes(child.doctorId);
    
            // If edit and selected value isn't in the filtered list, append it (marked inactive)
            if (props.isEdit && child.practiceServiceTypeId &&
                !matchedServiceTypes.some(o => o.practiceServiceTypeId === child.practiceServiceTypeId)) {
                const extra = allServiceTypeList?.find(
                    o => o.practiceServiceTypeId === child.practiceServiceTypeId
                );
                if (extra) matchedServiceTypes = [...matchedServiceTypes, { ...extra, isActive: 0 }];
            }
            return matchedServiceTypes;
        };
    
 
        const getChildSelectedServiceTypeValue = (practiceServiceTypeId) => {
           //console.log('getChildSelectedServiceTypeValue ' + practiceServiceTypeId );
           if (!practiceServiceTypeId) return null;
            if (props.isEdit) {
                const existingOption = stateServiceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
                if (!existingOption) {
                    const newOption = allServiceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
                    if (newOption) {
                        return { ...newOption, isActive: 0 };
                    }
                } else {
                    return existingOption;
                }
            } else {
                return stateServiceTypeList?.find((obj) => obj.practiceServiceTypeId === practiceServiceTypeId);
            }
        };

        // Get filtered equipment for main appointment
        const getMainEquipmentOptions = () => {
            let options = [];

            // Get filtered list based on service type
            if (inputData.practiceServiceTypeId && listEquipmentByServiceType && Object.keys(listEquipmentByServiceType).length > 0) {
                options = [...(listEquipmentByServiceType[inputData.practiceServiceTypeId] || equipmentList)];
            } else {
                options = [...(equipmentList || [])];
            }

            // In edit mode, if selected equipment is not in filtered list, add it from allEquipmentList
            if (props.isEdit && 
                inputData.equipmentId && 
                inputData.practiceServiceTypeId && 
                props.initialData?.practiceServiceTypeId && 
                inputData.practiceServiceTypeId === props.initialData.practiceServiceTypeId && 
                !options.some(obj => obj.equipmentId === inputData.equipmentId)) {
                const selectedEquipment = allEquipmentList?.find(obj => obj.equipmentId === inputData.equipmentId);
                
                if (selectedEquipment) {
                    const isRemoved = selectedEquipment.isActive === 1 ? true : false;
                    options = [...options, { ...selectedEquipment, isRemoved }];
                }
            }
            
            return options;
        };

        // Get filtered equipment for child appointment
        const getChildEquipmentOptions = (index) => {
            const child = inputData.childAppointments?.[index];
            let options = [];

            // Get filtered list based on service type
            if (child?.practiceServiceTypeId && listEquipmentByServiceType && Object.keys(listEquipmentByServiceType).length > 0) {
                options = [...(listEquipmentByServiceType[child.practiceServiceTypeId] || equipmentList)];
            } else {
                options = [...(equipmentList || [])];
            }
            // In edit mode, if selected equipment is not in filtered list, add it from allEquipmentList
            const initialChild = childAppointments?.[index];
            //console.log("initialChild:: "+JSON.stringify(initialChild));
            if (props.isEdit && 
                child?.equipmentId && 
                child?.practiceServiceTypeId && 
                initialChild?.practiceServiceTypeId && 
                child.practiceServiceTypeId === initialChild.practiceServiceTypeId && 

                !options.some(obj => obj.equipmentId === child.equipmentId)) {
                const selectedEquipment = allEquipmentList?.find(obj => obj.equipmentId === child.equipmentId);
                //console.log("selectedEquipment:: "+JSON.stringify(selectedEquipment));
                if (selectedEquipment) {
                    const isRemoved = selectedEquipment.isActive === 1 ? true : false;
                    options = [...options, { ...selectedEquipment, isRemoved }];
                }
            }
           // console.log("Child Equipment Options after edit check:: "+JSON.stringify(options));
            return options;
        };  

    return (
        <>
        {props.disabled ?
            <DimLoader loadMessage="Saving appointment(s)..." /> : null}
        <div className=" fields p-3">
            <div className="row">
                {/* <button type="button" className="accordion-header">Patient Details</button> */}
                <div className="required field col-md-9 col-12">
                    {/* {inputData.patientId} */}
                    <label><i className="icon user outline" /> Choose Patient</label>
                    <div className='col-12 input-group'>
                        <AsyncSelect
                            classNamePrefix="react-select"
                            className="react-select-container"
                            value={(patientList && inputData.patientId ? patientList.find(obj => obj.id === inputData.patientId) : null)}
                            name="patientId"
                            loadOptions={rePatientLoad}
                            isDisabled={props.isEdit}
                            placeholder="Search Patient"
                            onChange={e => {
                                if (e?.id) {
                                    inputChange({
                                        target:
                                            { value: e.id, name: 'patientId' }

                                    });
                                    setPatientList([e])
                                }
                                else if (e?.patientId) {
                                    inputChange({
                                        target:
                                            { value: e.patientId, name: 'patientId' }

                                    });
                                    setPatientList([e])
                                }
                                else {
                                    inputChange({
                                        target: {
                                            value: null, name: 'patientId'
                                        }
                                    })
                                }
                            }}
                            getOptionLabel={(option) => {
                                return (
                                    <div className="d-flex row">
                                        <span className="col">{option.firstName} {option.lastName}</span>
                                        <span className='col text-start'><i className='icon birthday cake' />{moment.utc(option.dob).format("M/D/YYYY").toString()}</span>
                                        {state.permissions.patientContactInfo && <>
                                        <span className='col text-end'>
                                            {option.mobile && option.mobile != '' || option.patientPhone && option.patientPhone != '' ?
                                                <>
                                                    <i className='icon phone' />
                                                    {option.mobile && option.mobile != '' ? Utilities.toPhoneNumber(option.mobile) : option.patientPhone && option.patientPhone != '' ? Utilities.toPhoneNumber(option.patientPhone) : null}
                                                </> : null}
                                        </span>
                                        </>}
                                    </div>
                                )
                            }}
                            getOptionValue={(option) => option.id}
                            noOptionsMessage={(e) =>
                                <button className='btn btn-primary form-control' onClick={e => { e.preventDefault(); setShowAdd(true) }}>Add Patient</button>}
                        />
                    </div>
                    <span className="error-message">{errors.patientId}</span>
                </div>
                <div className="required field col-md-3 col-12">
                    <label>Patient Type</label>
                    {patientTypeList && patientTypeList.length > 0 && <HPTSelect
                        options={patientTypeList}
                        name="patientType"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        //isLoading={isLoader_PatientType}
                        value={patientTypeList && inputData.practicePatientTypeId ? patientTypeList.find(obj => obj.practicePatientTypeId === inputData.practicePatientTypeId) : null}
                        onChange={e => {
                            inputChange({
                                target:
                                    { value: e.practicePatientTypeId, name: 'practicePatientTypeId' }
                            })
                        }}
                        getOptionLabel={(option) => option.patientType}
                        getOptionValue={(option) => option.practicePatientTypeId}
                        />}
                    <span className="error-message">{errors.practicePatientTypeId}</span>
                </div> 

                {/* {selectedPatient && <div className="required field col-6">
                    {selectedPatient.patientTags && selectedPatient.patientTags.map(tag => {
                            return (
                                <span className={`badge text-white me-1 bg-info`}>{tag.name}</span>
                            )
                    })}
                </div>} */}
                <div className="required field col-md-6 col-12">
                    <label>Location</label>
                    <PracticeLocationSelector locationId={props.isEdit ? props?.initialData?.practiceLocationId : null} disabled={true} dontResetState={true} onSelected={onLocationChanged}/>
                </div>

                <div className="required field col-md-6 col-12">
                <label>Appointment Location</label>
                <HPTSelect
                    name="appointmentLocationType"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={[
                    { label: "Office", value: "Office" },
                    { label: "Virtual Consultation", value: "VirtualConsult" },
                    { label: "Client Location", value: "ClientLocation" }
                    ]}
                    value={
                    inputData.appointmentLocationType
                        ? { label: inputData.appointmentLocationType.replace(/([A-Z])/g, ' $1').trim(), value: inputData.appointmentLocationType }
                        : { label: "Office", value: "Office" }
                    }
                    onChange={(selected) =>
                    inputChange({
                        target: {
                        name: "appointmentLocationType",
                        value: selected.value,
                        },
                    })
                    }
                />
                </div>

                <div className="field col-12">
                        <label className="d-flex justify-content-between align-items-center">
                            Search Provider
                            <div className="form-check form-check-inline" style={{display: 'flex',alignItems: 'center'}}>
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={providerRequested}
                                    name="providerRequested"
                                    onChange={e => inputChange(e)}
                                />
                                <label className="form-check-label ms-2">Provider Requested</label>
                            </div>
                        </label>
                    <HPTSelect
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={doctorList}
                        isDisabled={!doctorList}
                        isClearable={true}
                        isSearchable
                        name="doctorId"
                        //isLoading={isLoader_Provider}
                        value={doctorList && (inputData.doctorId) ? doctorList.find(obj => obj.id === (inputData.doctorId)) : null}
                        onChange={e => {
                            if (e?.id) {
                                inputChange({
                                    target:
                                        { value: e.id, name: 'doctorId' }
                                })
                            }
                            else {
                                inputChange({
                                    target:
                                        { value: null, name: 'doctorId' }
                                })
                            }
                        }}
                        getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                        getOptionValue={(option) => option.doctorId}
                    />
                    {/* <span className="error-message">{errors.doctorId ? 'Provider is a required field' : null}</span> */}
                </div>
                    <div className="required field col-md-6 col-12">
                        <label>Service Type</label>
                        {(props.isEdit ? serviceTypeList && allServiceTypeList : serviceTypeList) ? (
                            <HPTSelect
                                options={getServiceTypeOptions(inputData.practiceServiceTypeId)}
                                classNamePrefix="react-select"
                                className="react-select-container"
                                name="practiceServiceTypeId"
                                isDisabled={!props.edit ? false : true || inputData.doctorId}
                                value={getSelectedServiceTypeValue(inputData.practiceServiceTypeId)}
                                onChange={(e) => {
                                    inputChange({
                                        target: { value: e.practiceServiceTypeId, name: 'practiceServiceTypeId' },
                                    });
                                }}
                                getOptionLabel={(option) => {
                                    if (option.isActive !== 1 || 
                                        (inputData.doctorId && 
                                         inputData.doctorId !== '999999999' && 
                                         doctorList && 
                                         !doctorList?.find(d => d.id === inputData.doctorId)?.services?.some(ds => ds.practiceServiceTypeId === option.practiceServiceTypeId))) {
                                        return <span style={{color: 'red'}}>{option.practiceServiceType} (Inactive)</span>;
                                    }
                                    return option.practiceServiceType;
                                }}
                                getOptionValue={(option) => option.practiceServiceTypeId}
                            />
                        ) : null}
                        <span className="error-message">{errors.practiceServiceTypeId}</span>
                    </div>
                <div className="required field col-md-6 col-12">
                    <label>Status</label>
                    <HPTSelect
                        options={statusList}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="status"
                        //isLoading={isLoader_Status}
                        value={statusList && inputData.practiceAppointmentStatusCodeId ? statusList.find(obj => obj.practiceAppointmentStatusCodeId == inputData.practiceAppointmentStatusCodeId) : null}
                        onChange={e => {
                            inputChange({
                                target:
                                    { value: e.practiceAppointmentStatusCodeId, name: 'practiceAppointmentStatusCodeId' }
                            })
                        }}
                        getOptionLabel={(option) => option.appointmentStatusLabel}
                        getOptionValue={(option) => option.practiceAppointmentStatusCodeId}
                    />
                    <span className="error-message">{errors.practiceAppointmentStatusCodeId}</span>
                </div>
                {state.permissions.patientContactInfo && <>
                <div className="field col-lg-6 col-12">
                    <label>Phone</label>
                    <InputMask
                        placeholder="Phone"
                        type="text"
                        name="phone"
                        mask="(999) 999-9999"
                        unmask="true"
                        value={inputData.patientPhone}
                        onChange={(e) => {
                            e.preventDefault();
                            inputChange(e);
                        }}
                        editable="true"
                    />
                    <span className="error-message">{errors.phone}</span>
                </div>
                {/* {inputData.patientPhone} */}
                <div className="field required col-lg-6 col-12">
                    <label>Email</label>
                    <input type="text"
                        value={inputData.email}
                        onChange={e => { e.preventDefault(); inputChange(e) }}
                        name="email"
                        placeholder="Email" />
                    <span className="error-message">{errors.email}</span>
                </div>
                </>}
                <div className="field required col-lg-5 col-12">
                    <label>Start Date</label>
                    <input type="datetime-local"
                        className="form-control"
                        value={inputData.fromDate && moment(inputData.fromDate).format('YYYY-MM-DDTHH:mm')}
                        min={Utilities.toDateTimeLocale((new Date()))}
                        onChange={e => { e.preventDefault(); updateTime(e); }}
                        name="fromDate"
                    />
                    <span className="error-message">{errors.fromDate}</span>
                </div>
                <div className="field required col-lg-2 col-md-4 col-12">
                    <label>Duration</label>
                    <input type="number"
                        value={inputData.duration}
                        onChange={e => {
                            e.preventDefault();
                            updateTime(e);
                        }}
                        name="duration"
                        min={30}
                        step={15} />
                    <span className="error-message">{errors.duration}</span>
                </div>
                <div className="field required col-lg-5 col-12">
                    <label>End Date</label>
                    <input type="datetime-local"
                        className="form-control"
                        value={inputData.toDate && moment(inputData.toDate).format('YYYY-MM-DDTHH:mm')}
                        onChange={e => {
                            e.preventDefault(); updateTime(e);
                        }}
                        name="toDate"
                    // disabled
                    />
                    <span className="error-message">{errors.toDate}</span>
                </div>

                <div className="field col-md-6 col-12">
                    <label>Room</label>
                    {roomList && <HPTSelect
                        options={props.isEdit 
                            && inputData.practiceLocationRoomId 
                            && roomList.find(obj => obj.practiceLocationRoomId === inputData.practiceLocationRoomId)===undefined 
                            ? [ ...roomList,allRoomList.find(obj => obj.practiceLocationRoomId === inputData.practiceLocationRoomId)].filter((item) => item !== undefined):roomList}
                        //isLoading={isLoader_Room}
                        classNamePrefix="react-select"
                        className="react-select-container"
                        name="practiceLocationRoomId"
                        value={roomList && inputData.practiceLocationRoomId ? (props.isEdit ? allRoomList.find(obj => obj.practiceLocationRoomId === inputData.practiceLocationRoomId): roomList.find(obj => obj.practiceLocationRoomId === inputData.practiceLocationRoomId)) : null}
                        onChange={e => {
                            inputChange({
                                target:
                                    { value: e.practiceLocationRoomId, name: 'practiceLocationRoomId' }
                            })
                        }}
                        getOptionLabel={(option) => option.isActive === 1 ? option.room : `${option.room}(Inactive)`}
                        getOptionValue={(option) => option.practiceLocationRoomId}
                    />}
                </div>
                <div className="field col-md-6 col-12">
                    <label>Equipment</label>
                    {equipmentList && <HPTSelect
                        key={`equipment-${inputData.practiceServiceTypeId}-${inputData.equipmentId || 'none'}`}
                        options={getMainEquipmentOptions()}
                        //isLoading={isLoader_Equipment}
                        classNamePrefix="react-select"
                        className="react-select-container"
                        name="equipmentId"
                        isClearable={true}
                        value={(() => {
                            if (!inputData.equipmentId) return null;
                            const options = getMainEquipmentOptions();
                            return options.find(obj => obj.equipmentId === inputData.equipmentId);
                        })()}
                        onChange={e => {
                            inputChange({
                                target:
                                    { value: e?.equipmentId || null, name: 'equipmentId' }
                            })
                        }}
                        getOptionLabel={(option) => {
                            if (!props.isEdit) {
                                return option.description;
                            }
                            //console.log("option in equipment:: "+JSON.stringify(option))
                            const isInactive = option.isActive !== 1;
                            const isRemoved = option.isRemoved === true;
                            
                            if (isInactive) {
                                return `${option.description} (Inactive)`;
                            }
                            if (isRemoved) {
                                return `${option.description} (Removed)`;
                            }
                            return option.description;
                        }}
                        getOptionValue={(option) => option.equipmentId}
                    />}
                    {/* {inputData.equipmentId && inputData.equipmentId} */}
                </div>
                <div className="field col-12">
                    <label>Memo</label>
                    <textarea placeholder="Memo"
                        className="form-control"
                        value={inputData.memo || ""}
                        onChange={e => { e.preventDefault(); inputChange(e) }}
                        name="memo"
                        rows={2}
                    ></textarea>
                    <span className="error-message">{errors.memo}</span>
                </div>
                {/* show add child apt button only for new appointment or for updating main apt, hide for child apt while editing */}
                {!(props.isEdit
                    && props.initialData
                    && props.initialData.parentGroupId && props.initialData.parentGroupId !== "") ? <div style={{ textAlign: 'center', padding: "10px 0px 10px 0px" }}>
                    <button disabled={props.disabled} className="btn btn-primary" onClick={e => { e.preventDefault(); getItems(); }}>{'Add Service'}</button>
                </div > : ""}

                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable" >
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                 style={getListStyle(snapshot.isDraggingOver)}
                                {...provided.droppableProps}>
                                {childAppointments && childAppointments.length > 0 && childAppointments.map((item, index) => {
                                    return (<Draggable key={item.sequenceId} draggableId={item.sequenceId} index={index}   >
                                        {renderDraggable((provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                // style={getItemStyle(
                                                //     snapshot.isDragging,
                                                //     provided.draggableProps.style
                                                // )}
                                                className="ui segment"
                                            >
                                                <div className='row'>
                                                    <div className="field col-md-6 col-12">
                                                        <label>Search Provider</label>
                                                        <HPTSelect
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            options={doctorList}
                                                            isDisabled={!doctorList}
                                                            isClearable={true}
                                                            isSearchable
                                                            name="doctorId"
                                                            //isLoading={isLoader_Provider}
                                                            value={doctorList && inputData.childAppointments && inputData.childAppointments[index]?.doctorId ? doctorList.find(obj => obj.id === inputData.childAppointments[index]?.doctorId) : null}
                                                            onChange={e => {
                                                                if (e?.id) {
                                                                    inputSubAptChange({
                                                                        target:
                                                                            { index: index, value: e.id, name: "doctorId" }
                                                                    })
                                                                }
                                                                else {
                                                                    inputSubAptChange({
                                                                        target:
                                                                            { index: index, value: null, name: 'doctorId' }
                                                                    })
                                                                }
                                                            }}
                                                            getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                                                            getOptionValue={(option) => option.doctorId}
                                                        />
                                                        {/* <span className="error-message">{errors.childAppointments[index]?.doctorId ? 'Provider is a required field' : null}</span> */}
                                                    </div>
                                                    <div className="required field col-md-6 col-12">
                                                        <label>Service Type</label>
                                                        {(props.isEdit ? serviceTypeList && allServiceTypeList : serviceTypeList) ? (
                                                            <HPTSelect
                                                                key={index}
                                                                options={getChildServiceTypeOptions(index)}
                                                                classNamePrefix="react-select"
                                                                className="react-select-container"
                                                                name="practiceServiceTypeId"
                                                                isDisabled={!props.edit ? false : true || (inputData.childAppointments && item?.doctorId)}
                                                                value={getChildSelectedServiceTypeValue(item.practiceServiceTypeId)}
                                                                onChange={(e) => {
                                                                    inputSubAptChange({
                                                                        target: { index: index, value: e.practiceServiceTypeId, name: 'practiceServiceTypeId' },
                                                                    });
                                                                    //console.log(e.practiceServiceTypeId)
                                                                    //updating child appt duration
                                                                    if (e.practiceServiceTypeId) {
                                                                        const selectedServiceType = getChildSelectedServiceTypeValue(e.practiceServiceTypeId);
                                                                        if (selectedServiceType) {
                                                                            inputSubAptChange({
                                                                                target: { index: index, value: selectedServiceType.defaultDuration, name: 'duration' },
                                                                            });
                                                                        }
                                                                    }
                                                                }}
                                                                getOptionLabel={(option) => {
                                                                    if (option.isActive !== 1 || 
                                                                        (item?.doctorId && 
                                                                         item.doctorId !== '999999999' && 
                                                                         doctorList && 
                                                                         !doctorList?.find(d => d.id === item.doctorId)?.services?.some(ds => ds.practiceServiceTypeId === option.practiceServiceTypeId))) {
                                                                        return <span style={{color: 'red'}}>{option.practiceServiceType} (Inactive)</span>;
                                                                    }
                                                                    return option.practiceServiceType;
                                                                }}
                                                                getOptionValue={(option) => option.practiceServiceTypeId}
                                                            />
                                                        ) : null}

                                                        {/* <span className="error-message">{errors.childAppointments[index]?.practiceServiceTypeId}</span> */}
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="field required col-md-3 col-sm-6 col-12">
                                                        <label>Duration</label>
                                                        <input type="number"
                                                            value={inputData.childAppointments && inputData.childAppointments[index]?.duration}
                                                            onChange={e => {
                                                                e.preventDefault();
                                                                inputSubAptChange({
                                                                    target:
                                                                        { index: index, value: e.target.value, name: 'duration' }
                                                                })
                                                            }}
                                                            name="duration"
                                                            min={30}
                                                            step={15} />
                                                        {/* <span className="error-message">{errors.childAppointments[index]?.duration}</span> */}
                                                    </div>
                                                    <div className="field col-md-3 col-sm-6 col-12">
                                                        <label>Room</label>
                                                        {roomList && <HPTSelect
                                                            options={props.isEdit 
                                                                && inputData.childAppointments 
                                                                && inputData.childAppointments[index]?.practiceLocationRoomId
                                                                && roomList.find(obj => obj.practiceLocationRoomId === inputData.childAppointments[index]?.practiceLocationRoomId)===undefined 
                                                                ? [ ...roomList,allRoomList.find(obj => obj.practiceLocationRoomId === inputData.childAppointments[index]?.practiceLocationRoomId)].filter((item) => item !== undefined):roomList}
                                                            //isLoading={isLoader_Room}
                                                            classNamePrefix="react-select"
                                                            className="react-select-container"
                                                            name="practiceLocationRoomId"
                                                            value={roomList && inputData.childAppointments && inputData.childAppointments[index]?.practiceLocationRoomId ? (props.isEdit ? allRoomList.find(obj => obj.practiceLocationRoomId === inputData.childAppointments[index]?.practiceLocationRoomId): roomList.find(obj => obj.practiceLocationRoomId === inputData.childAppointments[index]?.practiceLocationRoomId)) : null}
                                                            onChange={e => {
                                                                inputSubAptChange({
                                                                    target:
                                                                        { index: index, value: e.practiceLocationRoomId, name: 'practiceLocationRoomId' }
                                                                })
                                                            }}
                                                            getOptionLabel={(option) => option.isActive === 1 ? option.room : `${option.room} (Inactive)`}
                                                            getOptionValue={(option) => option.practiceLocationRoomId}
                                                        />}
                                                    </div>
                                                    <div className={`field ${isMobile ? 'col-12' : 'col-md-5 col-10'}`}>
                                                        <label>Equipment</label>
                                                        {equipmentList && <HPTSelect
                                                            key={`child-equipment-${index}-${item.practiceServiceTypeId}-${item.equipmentId || 'none'}`}
                                                            options={getChildEquipmentOptions(index)}
                                                            //isLoading={isLoader_Equipment}
                                                            classNamePrefix="react-select"
                                                            className="react-select-container"
                                                            name="equipmentId"
                                                            isClearable={true}
                                                            value={(() => {
                                                                const childEquipmentId = inputData.childAppointments?.[index]?.equipmentId;
                                                                if (!childEquipmentId) return null;
                                                                const options = getChildEquipmentOptions(index);
                                                                return options.find(obj => obj.equipmentId === childEquipmentId);
                                                            })()}
                                                            onChange={e => {
                                                                inputSubAptChange({
                                                                    target:
                                                                        { index: index, value: e?.equipmentId || null, name: 'equipmentId' }
                                                                })
                                                            }}
                                                            getOptionLabel={(option) => {
                                                                if (!props.isEdit) {
                                                                    return option.description;
                                                                }
                                                                
                                                                const isInactive = option.isActive !== 1;
                                                                const isRemoved = option.isRemoved === true;
                                                                
                                                                if (isInactive) {
                                                                    return `${option.description} (Inactive)`;
                                                                }
                                                                if (isRemoved) {
                                                                    return `${option.description} (Removed)`;
                                                                }
                                                                return option.description;
                                                            }}
                                                            getOptionValue={(option) => option.equipmentId}
                                                        />}
                                                    </div>
                                                    <div className={`field ${isMobile ? 'col-12 text-center mt-2 mb-2' : 'col-md-1 col-2 d-flex align-items-end justify-content-center'}`}>
                                                        <button className={`btn btn-primary ${isMobile ? 'btn-sm' : ''}`} disabled={props.disabled} onClick={e => {
                                                            e.preventDefault();
                                                            const newChildAppointments = [...childAppointments];
                                                            newChildAppointments.splice(index, 1);
                                                            setChildAppointments(
                                                                newChildAppointments
                                                            );
                                                        }} title="Delete Service">
                                                            <i className="icon trash" /> {isMobile && 'Delete Service'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Draggable>)
                                })}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                {props.isEdit && <div className='col row-fluid btn d-flex align-items-center'>
                    <span>
                        {inputData.modifiedBy
                            ? `Last modified: ${inputData.modifiedBy}, ${moment(inputData.modifiedOn).format("MM-DD-YYYY h:mm A")}`
                            : `Created by: ${inputData.createdBy}, ${moment(inputData.createdOn).format("MM-DD-YYYY h:mm A")}`
                        }
                    </span>
                </div>}
               
                <div className="mt-3 d-flex justify-content-between modal-button-bar">
                    <div className='col-auto'>
                        <button disabled={props.disabled} className="btn btn-primary" onClick={e => { e.preventDefault(); submitHandlerCatch({ ...inputData }) }}>{props.submitLabel || 'Update'}</button>
                        {props.additionalButton}
                    </div >
                    <div className='col-auto'>
                        {props.onClose && <button className="btn btn-secondary float-right" onClick={e => { e.preventDefault(); props.onClose() }}>Close</button>}
                    </div>
                </div >
            </div>
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }} title="Add Patient">
                <AddPatient isModal onClose={() => { setShowAdd(false) }} />
            </ModalBox>
        </div >
        </>
    )
}

export default AppointmentForm